<template>
  <div class="c-route-step">
    <div class="c-route-step__content">
      <div class="c-route-step__icon" :class="'c-route-step__icon--' + type" />
      <div class="c-route-step__description" v-if="description">
        {{ description }}
      </div>
      <div class="c-route-step__start" v-if="start">
        {{ start }}
      </div>
      <o-route-trajectory
        :color="trajectory.color"
        :number="trajectory.number"
        :label="trajectory.label"
        :sublabel="trajectory.sublabel"
        :duration="trajectory.duration"
        v-if="trajectory"
      />
      <div class="c-route-step__end" v-if="end">
        {{ end }}
      </div>
    </div>
    <div class="c-route-step__footer">
      <o-button label="Koop ticket" />
    </div>
  </div>
</template>

<script>
import ORouteTrajectory from '@/components/ORouteTrajectory'
export default {
  name: 'ORouteStep',
  components: {
    ORouteTrajectory
  },
  props: {
    type: {
      type: String,
      default: null
    },
    start: {
      type: String,
      default: null
    },
    end: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    trajectory: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss">
.c-route-step {
  background: #fff;
  box-shadow: 0 0.1rem 0.3rem rgba(#000, 0.2);
  border-radius: 0.8rem;
  display: flex;
  flex-direction: column;
  font-size: 1.4rem;
  margin-left: 1.2rem;
}

.c-route-step__content {
  padding: 1.6rem 1.6rem 1.6rem 2.8rem;
  position: relative;
}

.c-route-step__icon {
  background: currentColor;
  bottom: 2.3rem;
  color: $gray-700;
  left: -0.2rem;
  position: absolute;
  top: 2.4rem;
  width: 0.4rem;

  &:before {
    background-color: currentColor;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 1.6rem 1.6rem;
    border-radius: 50%;
    content: '';
    height: 2.4rem;
    position: absolute;
    left: -1rem;
    top: -1.2rem;
    width: 2.4rem;
    z-index: 2;
  }

  &:after {
    background: currentColor;
    border-radius: 50%;
    bottom: -0.6rem;
    content: '';
    height: 1.2rem;
    position: absolute;
    left: -0.4rem;
    width: 1.2rem;
  }
}

.c-route-step__icon--walk {
  color: #3a8ae3;

  &:before {
    background-image: url('/icons/walk.svg');
  }
}

.c-route-step__icon--bus,
.c-route-step__icon--tram {
  color: #ddbf40;
}

.c-route-step__icon--bus:before {
  background-image: url('/icons/bus.svg');
}

.c-route-step__icon--tram:before {
  background-image: url('/icons/tram.svg');
}

.c-route-step__icon--train {
  color: #022c9c;

  &:before {
    background-image: url('/icons/train.svg');
  }
}

.c-route-step__icon--bike {
  color: #9c023d;

  &:before {
    background-image: url('/icons/bike.svg');
  }
}

.c-route-step__start,
.c-route-step__end {
  font-weight: 600;
  letter-spacing: -0.033rem;
}

.c-route-step__start {
  margin-bottom: 1.2rem;
}

.c-route-step__end {
  margin-top: 1.2rem;
}

.c-route-step__footer {
  border-top: 0.1rem solid rgba(#000, 0.1);
  padding: 1.6rem;
}
</style>
